module.exports = __webpack_public_path__ + "img/upload-gray.daf25fbf.svg";